<span class="currencyIcon" [class.normalFont]="!['INR','USD','GBP','EUR'].includes(currency)" [innerHTML]="currency | currencyIcon"></span>
